export default __webpack_public_path__ + "static/media/account-plus.49dc6103.svg";